const BACKEND_ERROR_MAP: Record<string, string> = {
    "order confirmation failed": "Conferma ordine non riuscita. Riprova.",
    "missing orderSnapshot": "Operazione non consentita",
    "locker not found": "Operazione non consentita",
    "shop is closed": "Il negozio è chiuso",
    "invalid id": "Operazione non consentita",
    "transition failed": "Operazione non consentita",
    "bundles are only supported on the new catalog flow": "Operazione non consentita",
    "bundleId and upsellingId are mutually exclusive": "Operazione non consentita",
};

const BACKEND_ERROR_CODE_MAP: Record<number, string> = {
    122: "Prodotto non disponibile. Il tuo ordine è stato aggiornato, riprova.",
};

export function translateError(message: unknown): string {
    if (typeof message === 'string') {
        const key = Object.keys(BACKEND_ERROR_MAP).find(k => message.startsWith(k));
        return key ? BACKEND_ERROR_MAP[key] : message;
    }
    if (Array.isArray(message)) {
        for (const error of message) {
            if (BACKEND_ERROR_CODE_MAP[error.code]) {
                return BACKEND_ERROR_CODE_MAP[error.code];
            }
        }
    }
    return 'Operazione non consentita';
}
